import { pick } from 'lodash';
import React from 'react';
import { useEquipmentCodes } from './equipment-codes-provider';
import EquipmentCodeForm from '../../components/forms/equipment-code-form';
import EquipmentCodeFormContext from '../../components/forms/equipment-code-form-context';

const EquipmentCodesEdit = () => {
  const {
    setData,
    selectedEquipmentCode,
    updateEquipmentCode,
    multipleOptions,
    groupMultipleOptions,
    savedFormValues,
    setSavedFormValues,
  } = useEquipmentCodes();

  const isEquipCodeInOpenSoli =
    selectedEquipmentCode?.isEquipmentCodeInOpenSolicitation;

  const isEqPartiallyEditable = selectedEquipmentCode?.canPartialEdit;

  const isEqInContractYear = selectedEquipmentCode?.isEquipmentCodeContractYear;

  const onSubmit = (data) => {
    // Save form values before submission
    setSavedFormValues(data);

    const tags = { value: [] };
    if (data?.tags) {
      tags.value = data.tags;
    }
    const filteredData = pick(data, [
      'category',
      'code',
      'content',
      'program',
      'quantityRequired',
      'sequence',
      'status',
      'title',
      'unit',
    ]);

    const equipmentCode = {
      ...filteredData,
      tags,
      contentId: filteredData?.content?.id,
      year: Number(data?.year),
    };
    setData('SET_UPDATING_EQUIPMENT_CODE', equipmentCode);
    updateEquipmentCode({
      variables: {
        id: Number(selectedEquipmentCode.id),
        equipmentcode: equipmentCode,
      },
    });
  };

  const categoryOptions = multipleOptions
    ?.filter(
      (o) => o?.type === 'standardsCodeModel' && o?.uniqueKey === 'category',
    )
    .map((o) => ({ ...o, label: `${o.value} - ${o.label}` }));

  const isEqualOrGreaterThanCurrentYear = (year) => {
    const currentYear = multipleOptions.find((o) => o.currentYear === true);
    return year >= currentYear.value;
  };
  const isYearOption = (o) => o?.type === 'year' && o?.uniqueKey === 'year';

  const yearOptions = multipleOptions
    ?.filter((o) => isYearOption(o) && isEqualOrGreaterThanCurrentYear(o.value))
    .reverse();

  const tagOptions = multipleOptions
    ?.filter((o) => o?.type === 'standardsCodeModel' && o?.uniqueKey === 'tags')
    .map((o) => ({ ...o, label: `${o.label}` }));

  const unitOptions = [
    { label: '- Select -', value: '' },
    ...multipleOptions
      .filter(
        (o) => o?.type === 'standardsCodeModel' && o?.uniqueKey === 'units',
      )
      .map((o) => ({ ...o, label: `${o.value} - ${o.label}` })),
  ];

  const quantityRequiredOptions = multipleOptions
    ?.filter(
      (o) =>
        o?.type === 'standardsCodeModel' && o?.uniqueKey === 'quantityRequired',
    )
    .map((o) => ({ ...o, label: `${o.value} - ${o.label}` }));

  return (
    <EquipmentCodeFormContext
      equipmentCode={selectedEquipmentCode}
      savedValues={savedFormValues}
    >
      <EquipmentCodeForm
        yearOptions={yearOptions}
        categoryOptions={categoryOptions}
        quantityRequiredOptions={quantityRequiredOptions}
        unitOptions={unitOptions}
        tagOptions={tagOptions}
        formId="equipment-code-edit"
        handleSave={(d) => {
          onSubmit(d);
        }}
        isAddForm={false}
        programs={groupMultipleOptions?.program}
        isReadOnly={isEquipCodeInOpenSoli}
        isPartialEditable={isEqPartiallyEditable}
        isEqInContractYear={isEqInContractYear}
      />
    </EquipmentCodeFormContext>
  );
};

export default EquipmentCodesEdit;
